var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.115,
    height: 16.777,
    viewBox: "0 0 27.115 16.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password-view",
    transform: "translate(0 -19.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11272",
    "data-name": "Path 11272",
    d: "M13.556,19.062C5.929,19.062.17,26.938.17,26.938A.848.848,0,0,0,.2,27.991c.263.354,5.914,7.849,13.361,7.849,7.248,0,12.8-7.1,13.333-7.812a.849.849,0,0,0,.09-1.037c-.014-.02-.029-.041-.043-.06-.068-.092-5.8-7.868-13.38-7.868Zm0,1.7c5.386,0,10.2,5.063,11.609,6.69-1.409,1.629-6.223,6.7-11.609,6.7s-10.2-5.067-11.609-6.7C3.358,25.822,8.172,20.759,13.556,20.759Zm0,1.625a5.067,5.067,0,1,0,5.06,5.067A5.077,5.077,0,0,0,13.556,22.384Zm0,1.695a3.372,3.372,0,1,1-3.372,3.373,3.356,3.356,0,0,1,3.372-3.373Z",
    transform: "translate(0)",
    fill: "#7a7f8d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordView);
export default __webpack_public_path__ + "static/media/password-view.61168f49550874c6c7ec99a30812aac2.svg";
export { ForwardRef as ReactComponent };